import React, { useEffect, useState } from 'react';
import API from '../../api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import CustomerInfo from '../smallComponent/CustomerInfo';
import { useCustomers } from '../context/CustomerContext';

const OldProjectList = () => {
  
  const { allCustomers, fetchCustomers, loading } = useCustomers();



const doneCustomers = allCustomers.filter(c => c.status === 1 || c.status === 2);


  useEffect(() => {
    fetchCustomers();
  }, [allCustomers]);

  const getBarClass = (percent) => {
    if (percent >= 80) return 'bg-green-500';
    if (percent >= 50) return 'bg-yellow-400';
    return 'bg-red-500';
  };

  return (
    <div className="container mx-auto mt-8 px-4">
      <h2 className="text-2xl font-semibold mb-6">Old Project List</h2>

      <div className="overflow-x-auto border border-gray-300 rounded-md">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-800 text-white">
            <tr>
              <th className="px-3 py-2 text-left text-sm font-semibold">SN</th>
              <th className="px-3 py-2 text-left text-sm font-semibold">Customer Name</th>
              <th className="px-3 py-2 text-left text-sm font-semibold">Developer</th>
              <th className="px-3 py-2 text-left text-sm font-semibold">Work Details</th>
              <th className="px-3 py-2 text-left text-sm font-semibold">Work Process Details</th>
              <th className="px-3 py-2 text-left text-sm font-semibold">Call</th>
              <th className="px-3 py-2 text-left text-sm font-semibold">Mark Done</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {doneCustomers.length === 0 ? (
              <tr>
                <td colSpan="8" className="text-center py-4 text-gray-500">
                  No customers found.
                </td>
              </tr>
            ) : (
              doneCustomers.map((customer, index) => (
                <tr key={customer.id} className="hover:bg-gray-50">
                  <td className="px-3 py-2 whitespace-nowrap">{index + 1}</td>
                  <td className="px-3 py-2 whitespace-nowrap">
                    <CustomerInfo customer={customer} />
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-gray-700">
                    {customer.developer_name || <em className="text-gray-400">No developer</em>}
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-gray-700">{customer.work_details}</td>
                  <td className="px-3 py-2">
                    {Array.isArray(customer.work_process_details) && customer.work_process_details.length > 0 ? (
                      <ul className="list-disc list-inside text-sm text-gray-700 max-h-32 overflow-y-auto">
                        {customer.work_process_details.map((r, idx) => (
                          <li key={idx}>
                            <strong>{r.date || ''}:</strong> {r.text || ''}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <em className="text-gray-400">Work Process Details</em>
                    )}
                    <div className="mt-2 h-4 w-full bg-gray-200 rounded">
                      <div
                        className={`h-4 rounded text-xs text-white text-center leading-4 ${getBarClass(customer.work_percentage)}`}
                        style={{ width: `${customer.work_percentage}%` }}
                      >
                        {customer.work_percentage}%
                      </div>
                    </div>
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap">
                    {customer.contact_number ? (
                      <div className="flex flex-col space-y-1">
                        <a
                          href={`tel:${customer.contact_number}`}
                          className="inline-flex items-center justify-center px-3 py-1 rounded bg-green-600 text-white text-sm hover:bg-green-700"
                          title="Call"
                        >
                          <FontAwesomeIcon icon={faPhone} />
                        </a>
                        <a
                          href={`https://wa.me/${customer.contact_number}`}
                          target="_blank"
                          rel="noreferrer"
                          className="inline-flex items-center justify-center px-3 py-1 rounded bg-green-600 text-white text-sm hover:bg-green-700"
                          title="WhatsApp"
                        >
                          <FontAwesomeIcon icon={faWhatsapp} />
                        </a>
                      </div>
                    ) : (
                      <span className="text-gray-400 text-sm">No Contact</span>
                    )}
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap">
                    <button
                      className={`px-3 py-1 rounded text-sm ${
                        customer.due_amount > 0
                          ? 'bg-gray-400 cursor-not-allowed'
                          : 'bg-blue-500 hover:bg-blue-600 text-white'
                      }`}
                      disabled={customer.due_amount > 0}
                    >
                      Done
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default OldProjectList;
